import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import Accordion from "../../../../components/acordion/accordion";
import specializedFreshImg from "../../../../assets/imgs/services/international/specialized-fresh.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function SpecializedFresh() {
  const [tSpecializedFresh] = useTranslation("specializedFreshPage");
  const [tSMetaData] = useTranslation("metaData");
  const idSpecializedFresh = "1bbc1e07-50f9-4019-acb4-7f2023410d7b";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["especializado-submenu"])[3]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["specialized-submenu"])[3]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idSpecializedFresh}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Manejo Especial"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us[
              "03-Acceptance, Documentation and Pickup"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Special Handling"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("specializedFresh.title")}</title>
        <meta
          name="description"
          content={tSMetaData("specializedFresh.description")}
        />
      </Helmet>
      <ImageHeader
        section={tSpecializedFresh("header.section")}
        title={tSpecializedFresh("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tSpecializedFresh("description.content"))
        }
        contactSales={tSpecializedFresh("header.contact-sales")}
        imgBackground={specializedFreshImg}
      />
      <Accordion
        title={tSpecializedFresh("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tSpecializedFresh("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tSpecializedFresh("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tSpecializedFresh("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tSpecializedFresh("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tSpecializedFresh("accordion-3.content"))
        }
      />
    </>
  );
}

export default SpecializedFresh;
